import { getCartDrawerFlowStackBounds } from "./cartDrawerLayout";
import { isStaticCustomCartDrawer } from "../constants/custom-cart-drawer-template";
import { isProductPageSlotMode } from "../../shared/product-page-slot.js";

export const CART_DRAWER_PLACEMENT = {
  ABOVE_CART_ITEMS: "above_cart_items",
  BELOW_CART_ITEMS: "below_cart_items",
};

export function isCartProductOfferPopup(popup) {
  // Static Custom Cart Drawer is a full replacement overlay — not a theme cart widget.
  if (isStaticCustomCartDrawer(popup)) return false;

  const placement = popup?.generalSettings?.cartDrawerPlacement;
  if (
    placement === CART_DRAWER_PLACEMENT.ABOVE_CART_ITEMS ||
    placement === CART_DRAWER_PLACEMENT.BELOW_CART_ITEMS
  ) {
    return true;
  }

  const text = [
    popup?.title,
    popup?.template_id?.title,
    popup?.generalSettings?.title,
    popup?.category?.primary,
    popup?.template_id?.category?.primary,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return (
    text.includes("cart product offer") ||
    (text.includes("cart") && text.includes("product recommendation")) ||
    text.includes("cart drawer")
  );
}

export function getCartDrawerPlacement(popup) {
  return (
    popup?.generalSettings?.cartDrawerPlacement ||
    CART_DRAWER_PLACEMENT.BELOW_CART_ITEMS
  );
}

export function isEffectivelyEmbeddedPopup(popup) {
  if (isCartProductOfferPopup(popup)) return true;
  if (isProductPageSlotMode(popup)) return false;
  return !!popup?.generalSettings?.condition?.embed?.is_embedded;
}

/** Live storefront cart drawer: scale block layout to full slot width. */
export function isCartDrawerLiveFluidLayout(popup, isPreviewMode) {
  return isCartProductOfferPopup(popup) && !isPreviewMode;
}

/** Editor iframe: keep design canvas fixed; block drag/resize on cart drawer sections. */
export function isCartDrawerEditorLayoutLocked(popup, isPreviewMode) {
  return isCartProductOfferPopup(popup) && !!isPreviewMode;
}

function parseDimensionValue(value) {
  if (value == null || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const match = String(value).trim().match(/^([\d.]+)\s*(%|px)?$/i);
  if (!match) return Number(value) || 0;
  return Number(match[1]) || 0;
}

export function getCartDrawerWidgetBounds(popup) {
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(max-width:768px)").matches;
  const view = isMobile ? "mobile" : "desktop";
  const step = Array.isArray(popup?.schema) ? popup.schema[0] : null;
  const sections = Array.isArray(step?.section)
    ? step.section
    : Array.isArray(step?.sections)
      ? step.sections
      : [];

  if (isCartProductOfferPopup(popup)) {
    const flowBounds = getCartDrawerFlowStackBounds(sections, isMobile);
    return {
      width: flowBounds.width,
      height: flowBounds.height,
      scale: 1,
      displayWidth: flowBounds.width,
      displayHeight: flowBounds.height,
    };
  }

  let width = 0;
  let height = 0;

  sections.forEach((section) => {
    const position = section?.setting?.position?.displacement?.[view] || {};
    const dimension = section?.setting?.dimension?.[view] || {};
    width = Math.max(
      width,
      (Number(position.x) || 0) + parseDimensionValue(dimension.width)
    );
    height = Math.max(
      height,
      (Number(position.y) || 0) + parseDimensionValue(dimension.height)
    );
  });

  return {
    width: Math.max(width, 280),
    height: Math.max(height, 120),
    scale: 1,
    displayWidth: Math.max(width, 280),
    displayHeight: Math.max(height, 120),
  };
}
